import { findKey } from "lodash";
import { isClient } from "common/helper";
import { cleanEnv, str } from "envalid";

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str({ default: "0.0.0.0" }),
  REACT_APP_DEFAULT_LANG: str({ default: "th" }),
  NODE_ENV: str({ default: "development" }),
});

const config = {
  prod: {
    HOST: "https://dentsu-uat.zennite.co",
    API_ENDPOINT: "https://dentsu-uat.zennite.co/graphql",
    API: "https://dclaim.dentsujoy.com",
    BACKOFFICE_ENDPOINT: "https://dentsu-uat.zennite.co",
    APP_ENDPOINT: "https://dclaim.dentsujoy.com",
  },
  uat: {
    HOST: "https://dentsu-uat.zennite.co",
    API_ENDPOINT: "https://dentsu-uat.zennite.co/graphql",
    API: "https://dclaim.dentsujoy.com",
    BACKOFFICE_ENDPOINT: "https://dentsu-uat.zennite.co",
    APP_ENDPOINT: "https://dclaim.dentsujoy.com",
  },
  staging: {
    HOST: "https://dev.backoffice.bam.ldrive.io",
    API_ENDPOINT: "https://dev.backoffice.bam.ldrive.io/graphql",
    API: "https://dev.api.bam.ldrive.io",
    BACKOFFICE_ENDPOINT: "https://dev.backoffice.bam.ldrive.io",
    APP_ENDPOINT: "https://dev.app.bam.ldrive.io",
  },
  development: {
    HOST: "http://localhost:22202",
    API_ENDPOINT: "http://localhost:22201/graphql",
    API: "http://localhost:22201",
    BACKOFFICE_ENDPOINT: "http://localhost:22202",
    APP_ENDPOINT: "http://localhost:22203",
  },
};

export const getEnvByHost = () =>
  isClient ? findKey(config, { HOST: window.location.origin }) : null;

export const nodeEnv = getEnvByHost() || "development";

console.log("HOST : ", getEnvByHost());

const appEnvConfig = {
  prod: {
    HOST: "https://dclaim.dentsujoy.com",
    API_ENDPOINT: "https://dclaim-api.dentsujoy.com/graphql",
    API: "https://dclaim-api.dentsujoy.com",
  },
  uat: {
    HOST: "https://dclaim.dentsu-uat.zennite.co",
    API_ENDPOINT: "https://dclaim-api.dentsu-uat.zennite.co/graphql",
    API: "https://dclaim-api.dentsu-uat.zennite.co",
  },
  staging: {
    HOST: "https://dev.app.bam.ldrive.io",
    API_ENDPOINT: "https://dev.app.bam.ldrive.io/graphql",
    API: "https://dev.api.bam.ldrive.io",
  },
  development: {
    HOST: "http://localhost:22203",
    API_ENDPOINT: "http://localhost:22201/graphql",
    API: "http://localhost:22201",
  },
};

const MOCK_MSAL_CONFIG = {
  prod: {
    REACT_APP_MSAL_CLIENT_ID: "2461d802-bf29-4d60-a8bc-8f4bcc272ed7",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://dclaim.dentsujoy.com",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://dclaim.dentsujoy.com",
  },
  uat: {
    REACT_APP_MSAL_CLIENT_ID: "2461d802-bf29-4d60-a8bc-8f4bcc272ed7",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://dclaim.dentsu-uat.zennite.co",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://dclaim.dentsu-uat.zennite.co",
  },
  staging: {
    REACT_APP_MSAL_CLIENT_ID: "2461d802-bf29-4d60-a8bc-8f4bcc272ed7",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "https://dev.backoffice.bam.ldrive.io",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "https://dev.backoffice.bam.ldrive.io",
  },
  development: {
    REACT_APP_MSAL_CLIENT_ID: "2461d802-bf29-4d60-a8bc-8f4bcc272ed7",
    REACT_APP_MSAL_AUTHORITY: "https://login.microsoftonline.com/common",
    REACT_APP_MSAL_REDIRECT_URI: "http://localhost:22202",
    REACT_APP_MSAL_LOGOUT_REDIRECT_URI: "http://localhost:22202",
  },
};

export const appEnv = appEnvConfig[nodeEnv];

const env = {
  ...config[nodeEnv],
  ...MOCK_MSAL_CONFIG[nodeEnv],
  THEME: "dentsu", // bam | scg
  TENANT_ID: "dentsu",
};

console.log("ENV : ", env);
export default env;
